import { Center, Heading, HStack, Stack, Text } from '@chakra-ui/react';
import { LooseObject, StatusCodes, User } from 'api/types';
import { get, omit, sumBy } from 'lodash';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PendingValue } from '../../api/ControllingApi';
import { Card } from '../../layout/Card';
import StatusReasonBarChart from '../../pages/controlling/charts/StatusReasonBarChart';
import UserBarChart from '../../pages/controlling/charts/UserBarChart';

export interface PendProps {
  data: PendingValue | LooseObject;
  statusKey: string;
  statusCodes: StatusCodes | {};
  users: User[] | [];
  subContent?: any;
}

export const PendingStatusVsUser: FC<PendProps> = ({ data, statusKey, statusCodes, users, subContent = false }) => {
  const { t } = useTranslation();
  const pendingStatuses = omit(get(statusCodes, statusKey), [0, 100, 700, 900]);

  const groupedByStatus = get(data, 'grouped_by_status');
  const groupedByAssignee = get(data, 'grouped_by_assignee');

  return (
    <Card pt={4}>
      <Center>
        <Heading size={'xs'}>
          {t(`${statusKey}:label`)} ({t('controlling:right_now')})
        </Heading>
      </Center>
      <Stack alignItems={'center'}>
        <Stack p={2} width={'75%'}>
          <HStack>
            <Heading size={'xss'} ml={'8%'}>
              {t('controlling:grouped_by_status.label')}
            </Heading>
            <Text>
              {t('controlling:total')}: {sumBy(groupedByStatus, (obj: { total: number }) => obj.total)}
            </Text>
          </HStack>
          <StatusReasonBarChart
            data={groupedByStatus}
            statusKey={statusKey}
            statusCodes={pendingStatuses}
            reasons={get(statusCodes, statusKey + '_reasons')}
          />
        </Stack>

        <Stack p={2} width={'75%'}>
          <HStack>
            <Heading size={'xss'} ml={'8%'}>
              {t('controlling:grouped_by_assignee.label')}
            </Heading>
            <Text>
              {t('controlling:total')}: {sumBy(groupedByAssignee, (obj: { total: number }) => obj.total)}
            </Text>
          </HStack>
          <UserBarChart statusKey={statusKey} statusCodes={pendingStatuses} data={groupedByAssignee} users={users} />
        </Stack>
      </Stack>
      <Stack p={2}>{subContent}</Stack>
    </Card>
  );
};
